export default __webpack_public_path__ + "static/menu-do-light-f9fd8d841fb64b7e40702fb872e6d1a8919820c86d981fffda338c59b2f94b67.png";